// const ip = "https://204.152.194.241";

// export const cdnURL = `http://${ip}/webimages/`;
export const cdnURL = "https://cdn.rudytudysubs.com/webimages/";

export const atFolder = (route) => {
    return (filename) => `${cdnURL}${route}/${filename}`
}